import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { IPracticeEnemDaySummary } from '../../model/Enem';
import { getPracticeEnemOverview } from '../../queries/Enem';
import { practiceEnemPaths } from '../../utils/enemDay';

export const usePracticeEnemDaySelectionHook = () => {
  const { slug } = useParams();
  const navigate = useNavigate();

  const { data, isError, error, isPending } = useQuery({
    queryKey: ['fetch-practice-enem-overview', slug],
    queryFn: () => getPracticeEnemOverview(slug || ''),
    retry: false,
    refetchOnWindowFocus: false,
  });

  // Simulado sem segundo dia não tem o que escolher: a tela some e o aluno vai
  // direto para a prova, exatamente como era antes desta feature.
  useEffect(() => {
    if (data && !data.hasSecondDay) {
      navigate(practiceEnemPaths.exam(slug || '', null), { replace: true });
    }
  }, [data, navigate, slug]);

  const breadCrumbsItems = [
    {
      label: 'Simuladão Enem',
      href: practiceEnemPaths.list(),
    },
    {
      label: data?.name ?? '',
      href: '',
    },
  ];

  const goToDay = (day: IPracticeEnemDaySummary['day']) => {
    navigate(practiceEnemPaths.exam(slug || '', day));
  };

  const goToDayFeedback = (day: IPracticeEnemDaySummary['day']) => {
    navigate(practiceEnemPaths.feedback(slug || '', day));
  };

  return {
    slug,
    data,
    days: data?.days ?? [],
    isError,
    error,
    // Enquanto o redirect de etapa única não acontece, seguimos em loading para
    // não piscar a tela de escolha com um card só.
    isLoading: isPending || (!!data && !data.hasSecondDay),
    breadCrumbsItems,
    goToDay,
    goToDayFeedback,
  };
};
